import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import { TIMELINE } from "../../lib/data";

export const Timeline = () => {
  return (
    <section
      id="timeline"
      data-testid="timeline-section"
      className="relative bg-[#0a0a0a] py-24 sm:py-36"
    >
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <Reveal>
            <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] text-[#e62429] mb-6">
              <span className="h-px w-10 bg-[#e62429]" /> A partnership that continues to evolve
            </p>
            <h2 className="font-display uppercase text-white text-4xl sm:text-6xl leading-[0.9]">
              Red Bull, <span className="text-[#e62429]">across sports & cities.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-neutral-400 max-w-xs text-base">
              A decade of properties designed, run and grown — from soccer and
              kabaddi to downhill cycling and box cricket.
            </p>
          </Reveal>
        </div>

        <div
          data-testid="timeline-scroller"
          className="flex gap-5 overflow-x-auto pb-6 snap-x snap-mandatory -mx-5 px-5 sm:mx-0 sm:px-0 [scrollbar-width:thin]"
        >
          {TIMELINE.map((item, i) => (
            <motion.div
              key={i}
              data-testid={`timeline-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: (i % 4) * 0.06 }}
              className="group snap-start shrink-0 w-[260px] sm:w-[300px] border border-white/12 bg-[#121212] p-7 flex flex-col justify-between min-h-[240px] hover:border-[#e62429] transition-colors duration-300"
            >
              <div className="flex items-center justify-between">
                <span className="inline-block bg-[#e62429] px-3 py-1 font-display text-lg text-white">
                  {item.year}
                </span>
                <span className="h-3 w-3 rounded-full bg-white/20 group-hover:bg-[#e62429] transition-colors" />
              </div>
              <div>
                <h3 className="font-display uppercase text-2xl sm:text-3xl text-white leading-none">
                  {item.name}
                </h3>
                <p className="mt-3 text-sm uppercase tracking-[0.15em] font-bold text-neutral-500">
                  {item.sport}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
